import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "../../../utils";
import { useTranslation } from "react-i18next";
const PasswordInput = /*#__PURE__*/ React.forwardRef(({ className, autocomplete, ...props }, ref)=>{
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = React.useState(false);
    const togglePasswordVisibility = ()=>{
        setShowPassword((prev)=>!prev);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsx("input", {
                type: showPassword ? "text" : "password",
                autoComplete: autocomplete,
                className: cn("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 pr-10 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", className),
                ref: ref,
                ...props
            }),
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                onClick: togglePasswordVisibility,
                className: "absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent",
                "aria-label": showPassword ? t("hidePassword") : t("showPassword"),
                tabIndex: -1,
                children: showPassword ? /*#__PURE__*/ _jsx(EyeOff, {
                    className: "h-4 w-4 text-muted-foreground"
                }) : /*#__PURE__*/ _jsx(Eye, {
                    className: "h-4 w-4 text-muted-foreground"
                })
            })
        ]
    });
});
PasswordInput.displayName = "PasswordInput";
export { PasswordInput };

//# sourceMappingURL=password-input.js.map